import React from 'react';
import Skeleton from 'components/skeleton/Skeleton';
import styles from './bonuses.module.scss';

interface SkeletonBonusesProps {
  length?: number;
}

const SkeletonBonuses: React.FC<SkeletonBonusesProps> = ({ length = 7 }) => {
  return (
    <>
      {Array.from({ length }).map((_, index) => (
        <div key={`skeleton-bonus-${index}`} className={styles.bonusCard}>
          <div className={styles.iconWrapper}>
            <Skeleton
              variant="rectangular"
              width="100%"
              height="100%"
              borderRadius={12}
              animation="pulse"
              style={{
                cursor: 'default',
                border: 'none',
                backgroundColor: 'rgba(255, 255, 255, 0.05)',
              }}
            />
          </div>
          <Skeleton
            variant="text"
            width="60%"
            height={20}
            animation="pulse"
            style={{ marginTop: '12px', marginBottom: '8px' }}
          />
          <Skeleton
            variant="rectangular"
            width="90%"
            height={26}
            borderRadius={4}
            animation="pulse"
          />
        </div>
      ))}
    </>
  );
};

export default SkeletonBonuses;
